module.exports = __webpack_public_path__ + "6e6cb45ed992cbce778d170c62903202.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-s.png
// module id = 2066
// module chunks = 0